// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Text_inputWrapper__jH7SU","label":"Text_label__M4jVw","input":"Text_input__gzSuK","error":"Text_error__E7WGv"};